import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const state = () => ({
    data: {
        postalCode: null,
        houseNumber: null,
        houseNumberAddition: null,
        city: null,
        province: null,
        country: null,
    },
    loading: false,
    error: null,
});

const actions = {
    /**
     *
     * Get relation (depending on acl)
     *
     * @param commit
     * @param data
     * @returns {Promise<void>}
     */
    async searchAddress({commit}, data) {
        try {
            await commit('dataBegin');
            const response = await DataService.get('/search/address', data.value);
            await commit('dataSuccess', response.data);
            data.setAddress(response.data)
        } catch (err) {
            await commit('dataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
